import Appointment from "./Appointment";
import Status from "./Status";

export default class UpcomingUserAppointment {
    constructor(
        public readonly appointment: Appointment | null,
        public readonly status: Status,
    ) {}
}